// extracted by mini-css-extract-plugin
export default {"legacyTrigger":"LegacyMobileNavigationTrigger-LegacyMobileNavigationTrigger-module__legacyTrigger--Z5MSO"};